<script setup>
import {computed, onMounted, ref} from 'vue';

const shouldShowNavbar = computed(() => process.env.VUE_APP_SERVE === 'true');

const body = document.body;
const overlay = document.createElement('div');


onMounted(() => {
      overlay.classList.add('nav-overlay')
      // Append overlay to body
      body.appendChild(overlay);
    }
)


const toggle = () => {
  const navToggle = document.querySelector(".mobile-nav-toggle");
  const primaryNav = document.getElementById("primary-navigation");
  const iconList = document.getElementById("nav-icon-list");
  const iconClose = document.getElementById("nav-icon-close");
  const body = document.body;
  const overlay = document.createElement('div');

  const isVisible = primaryNav.hasAttribute("data-visible");

  // Set aria-expanded attribute based on visibility
  navToggle.setAttribute("aria-expanded", !isVisible);
  primaryNav.toggleAttribute("data-visible");
  overlay.classList.toggle('overlay-active');

  if (overlay.classList.contains('overlay-active')) {
    body.classList.add('no-scroll');
  } else {
    body.classList.remove('no-scroll');
  }


  // Toggle aria-hidden for icons
  iconList.setAttribute("aria-hidden", !isVisible);
  iconClose.setAttribute("aria-hidden", isVisible);
}

</script>

<template>

  <header v-if="shouldShowNavbar" class="header-section">
    <div class="section-container">
      <div class="nav-wrapper">
        <img src="/static/images/aiprofit-logo-line.svg" alt="Aiprofit" width="160px">

        <button class="mobile-nav-toggle" aria-controls="primary-navigation" aria-expanded="false" @click="toggle">
          <img class="icon-list"
               width="32px"
               id="nav-icon-list"
               src="/static/images/list.svg"
               alt="List"
               aria-hidden="false">
          <img class="icon-close"
               width="32px"
               id="nav-icon-close"
               src="/static/images/x-lg.svg"
               alt="Close"
               aria-hidden="true">

          <span class="visually-hidden">Menu</span>

        </button>

        <nav class="primary-navigation" id="primary-navigation">
          <ul role="list" class="nav-list">
            <li>
              <a class="nav-item" href="#">Home</a>
            </li>
            <li>
              <a class="nav-item" href="#">How it Works</a>
            </li>
            <li>
              <a class="nav-item" href="#">Guides</a>
            </li>
            <li>
              <a class="nav-item" href="#">Contact</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="color: red;" :href="`/tools/bet-calculator/each-way/`">Dev Link</a>
            </li>
          </ul>
        </nav>


      </div>
    </div>
  </header>
</template>
